import React, { useEffect, useState } from 'react'
import Loader from '../Loader/Loader'


import { message } from 'antd'
import { trackVoucher } from '../../Web Apis/Apis'

function VoucherTracking() {
    const [loading, setLoading] = useState(false)
    const [trackingData, setTrackingData] = useState([])

    const getMonitorVoucher = async () => {
        try {
            setLoading(true)

            const response = await trackVoucher()

            if (response?.data?.success) {
                setTrackingData(response?.data?.data)
            }

        } catch (error) {
            console.log("Admin fetch error", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.clear();
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getMonitorVoucher();
    }, [])

    return (
        <div className='p-4'>
            <div className='flex justify-between'>
                <h3 className='text-3xl font-bold'>Voucher Tracking Management</h3>

            </div>
            <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
                <thead>
                    <tr>
                        <th className="py-2 px-4 border-b text-center">S.No</th>
                        <th className="py-2 px-4 border-b text-center">Voucher Name</th>
                        <th className="py-2 px-4 border-b text-center">Sender Name</th>
                        <th className="py-2 px-4 border-b text-center">Receiver Name</th>
                        <th className="py-2 px-4 border-b text-center">Voucher Type</th>
                        <th className="py-2 px-4 border-b text-center">Promise Status</th>
                        {/* <th className="py-2 px-4 border-b text-center">Redeemed Status</th> */}
                        
                    </tr>
                </thead>
                <tbody>
                    {trackingData?.length > 0 ? (
                        trackingData?.map((data, index) => (
                            <tr key={data.id}
                                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                            >

                                <td className='py-2 px-4 border-b'>{index + 1}</td>
                                <td className='py-2 px-4 border-b'>{data?.voucherName}</td>
                                <td className='py-2 px-4 border-b'>{data?.senderName}</td>
                                <td className='py-2 px-4 border-b'>{data?.receiverName}</td>
                                <td className='py-2 px-4 border-b'>{data?.voucherType}</td>
                                <td className='py-2 px-4 border-b'>{data?.promiseFulfill ? "Fulfilled" : "Not Fulfilled"}</td>
                                {/* <td className='py-2 px-4 border-b'>{data?.redeemType ? "Redeemed" : "Not Redeemed"}</td> */}
                                

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No occassion category data found</td>
                        </tr>
                    )}

                </tbody>
            </table>
            {loading && <Loader/>}
        </div>
    )
}

export default VoucherTracking